import { RichText } from "prismic-reactjs"
import React from "react"
import Layout from "./layout"
import { linkResolver } from "../utils/linkResolver"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import SEOPost from "../components/seopost"

export default function Article({ data, pageContext: { next, previous } }) {
  const location = { pathname: `/blog/${data.prismicBlogPost.uid}` }
  const content = data.prismicBlogPost.dataRaw["blog_content"]
  const blogTitle = data.prismicBlogPost.dataRaw["blog_title"][0].text
  const blogImage = data.prismicBlogPost.dataRaw["blog_image"].url
  const thumbnailImage = data.prismicBlogPost.dataRaw["thumbnail_image"].url
  const imageAlt = data.prismicBlogPost.dataRaw["blog_image"].alt
  const descriptionPost = data.prismicBlogPost.dataRaw["article_description"][0].text

  return (
    <>
    <SEOPost title={`${blogTitle} | Bankjoy`} url={`https://bankjoy-headless.vercel.app/blog/${data.prismicBlogPost.uid}`} image={thumbnailImage} description={descriptionPost}/>
      <Layout location={location} containerClassName="px-8 mx-auto max-w-5xl">
        <div className="max-w-6xl mx-auto">
          <img
            src={blogImage}
            alt={imageAlt}
            className="rounded-md mt-12 "
          />
        </div>
        <h1 className="text-4xl md:text-center md:max-w-4xl md:mx-auto my-4 md:mb-16 md:mt-32 md:text-6xl">
          {blogTitle}
        </h1>
        <div className="max-w-2xl mx-auto blogArticle">
          <RichText render={content} linkResolver={linkResolver} />
        </div>
        <div className="mt-12 md:mt-16 grid grid-cols-2">
          <div className="max-w-xs col-start-1 col-end-2 justify-self-start">
            {previous && (
              <>
                <div className="text-sm">Previous Article</div>
                <Link
                  to={`/blog/${previous.uid}`}
                  className="hover:text-blue transition-colors font-semibold leading-5 block mt-1"
                >
                  {previous.dataRaw["blog_title"][0].text}
                </Link>
              </>
            )}
          </div>
          <div className="max-w-xs col-start-2 col-end-3 justify-self-end">
            {next && (
              <>
                <div className="text-sm">Next Article</div>
                <Link
                  to={`/blog/${next.uid}`}
                  className="hover:text-blue transition-colors font-semibold leading-5 block mt-1"
                >
                  {next.dataRaw["blog_title"][0].text}
                </Link>
              </>
            )}
          </div>
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  query($id: String) {
    prismicBlogPost(id: { eq: $id }) {
      dataRaw 
      uid
    }
  }
`
